import { createRequestTypes } from "../../utils";

export const FETCH_PRODUCTS = createRequestTypes("FETCH_PRODUCTS");
export const FETCH_PRODUCTS_BY_PAGE = createRequestTypes("FETCH_PRODUCTS_BY_PAGE");
export const FETCH_PRODUCTS_BY_FILTER = createRequestTypes("FETCH_PRODUCTS_BY_FILTER");

export const fetchProductsRequest = (products) => ({ type: FETCH_PRODUCTS.REQUEST, payload: { products } });
export const fetchProductsSuccess = (products) => ({ type: FETCH_PRODUCTS.SUCCESS, payload: { products } });
export const fetchProductsFailure = (error) => ({ type: FETCH_PRODUCTS.FAILURE, payload: { error } });

export const fetchProductsByPageRequest = (page = 1) => ({ type: FETCH_PRODUCTS_BY_PAGE.REQUEST, payload: { page } });
export const fetchProductsByPageSuccess = (products) => ({ type: FETCH_PRODUCTS_BY_PAGE.SUCCESS, payload: { products } });
export const fetchProductsByPageFailure = (error) => ({ type: FETCH_PRODUCTS_BY_PAGE.FAILURE, payload: { error } });

export const fetchProductsByFilterRequest = (page = 1, filters = {}) => ({ type: FETCH_PRODUCTS_BY_FILTER.REQUEST, payload: { page, filters } });
export const fetchProductsByFilterSuccess = (products) => ({ type: FETCH_PRODUCTS_BY_FILTER.SUCCESS, payload: { products } });
export const fetchProductsByFilterFailure = (error) => ({ type: FETCH_PRODUCTS_BY_FILTER.FAILURE, payload: { error } });